import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.scss'],
    standalone: false
})
export class ForgotComponent implements OnInit {

    public error = false;
    public loading = false;
    public sent: boolean | null = false;
    public forgotForm: UntypedFormGroup;
    constructor(
        protected formBuilder: UntypedFormBuilder,
        protected router: Router,
        protected authService: AuthService
    ) { }

    ngOnInit(): void {

        this.forgotForm = this.formBuilder.group({
            email: [null, Validators.required]
        });
    }

    public resetAction(): void {

        this.sent = false;
        this.error = false;
        const values = this.forgotForm.getRawValue();

        if (!this.isValidEmail(values.email)) {
            this.error = true;
            return;
        }

        this.loading = true;
        this.authService.forgot(values.email).subscribe(
            sent => {
                this.loading = false;
                this.sent = sent;
            }
        )
    }

    private isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
}
